import React from "react";

import "./DevTag.css"
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

const DevTag = () => {
	return (
    <p className="dev-tag">Designed by Anthony Shorey</p>
	);
};
export default DevTag;
